import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import {
  mostRecentListReducer,
  newsUserInfoReducer,
  newsletterSubReducer,
  subscribePageDataReducer,
  firstVisitReducer,
  newsletterBannerReducer,
} from "./Redux/reducers/newsReducer";
import { countryRedirectReducer } from "./Redux/reducers/countryReducer";
import {
  userDetailsReducer,
  duplicateEmailReducer,
  sendDataReducer,
  getIpDataReducer,
  getPageNameReducer,
  sendTwilioSMSReducer,
  freeTrialAccountReducer,
  redirectStatusReducer,
  addToProductListReducer,
  sendNotificationToUKReducer,
  chilipiperdemoReducer,
} from "./Redux/reducers/userReducer";

const reducer = combineReducers({
  mostRecentList: mostRecentListReducer,
  countryRedirectList: countryRedirectReducer,
  userDetails: userDetailsReducer,
  duplicateEmail: duplicateEmailReducer,
  sendData: sendDataReducer,
  getIpData: getIpDataReducer,
  getPageName: getPageNameReducer,
  newsUserInfo: newsUserInfoReducer,
  newsletterSub: newsletterSubReducer,
  sendTwilioSMS: sendTwilioSMSReducer,
  subscribePageData: subscribePageDataReducer,
  freeTrialAccount: freeTrialAccountReducer,
  redirectStatus: redirectStatusReducer,
  firstVisit: firstVisitReducer,
  newsletterBanner: newsletterBannerReducer,
  addToProductList: addToProductListReducer,
  sendNotificationToUK: sendNotificationToUKReducer,
  chilipiperdemo: chilipiperdemoReducer,
});

const initialState = {};

const middleware = [thunk];

const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
